import React from 'react';
import Styles from './styles.js';
const ArrivePay = ({ imgsrc, title, discription, reverse }) => {
  return (
    <div>
      {reverse == true ? (
        <div className="grid md:grid-cols-2 mb-14  gap-x-0  md:gap-x-12 gap-y-4 md:gap-y-0">
          <div className=" md:order-2 order-1 ">
            <img loading="lazy" className="img  w-full" src={imgsrc} alt="" />
          </div>
          <div
            className=" md:order-1 order-2 text-center
            flex flex-col justify-center items-center">
            <h1
              className="fs-36-45 fw-400 mt-4 md:mt-0 lg:mb-1"
              style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
              {title}
            </h1>
            <p
              className=" lg:mt-2 fw-400 fs-20-30"
              style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e', lineHeight: '30px' }}>
              {discription}
            </p>
          </div>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 mb-14  gap-x-0  md:gap-x-12 gap-y-4 md:gap-y-0">
          <div className=" order-1 ">
            <img loading="lazy" className="img  w-full" src={imgsrc} alt="" />
          </div>
          <div className="order-2 text-center  flex flex-col justify-center items-center">
            <h1
              className="fs-36-45 fw-400  mt-4 md:mt-0 lg:mb-1"
              style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
              {title}
            </h1>
            <p
              className="fw-400 mt-lg-2 fs-20-30"
              style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e', lineHeight: '30px' }}>
              {discription}
            </p>
          </div>
        </div>
      )}
      <Styles />
    </div>
  );
};

export default ArrivePay;
